<template>
  <div>
    <heading-one id="cmstitle" class="-margin-md _mb-0">
      <!--タイトル-->
      {{title}}
    </heading-one>
    <p id="cmsupdateat" class="date -textright -margin-md">
      <!--日付-->
      {{updateAt}}
    </p>
    <div id="cmscontens">
      <!--記事-->
      <slot></slot>
    </div>
  </div>
</template>

<script>

import HeadingOne from '../heading/HeadingOne'
import ListGroup from '../list/ListGroup'
import ListItem from '../list/ListItem'
import ElementBox from '../elements/element-box'
import HeadingIcon from '../heading/HeadingIcon'
import IconBox from '../icons/icon-box'
export default {
  name: 'cms-wrapper-template',
  metaInfo: {
    title: 'cms-wrapper-template'
  },
  components: {
    IconBox,
    HeadingIcon,
    ElementBox,
    ListItem,
    ListGroup,
    HeadingOne
  },
  props: ['title', 'updateAt'],
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'root'
      },
      {
        text: 'トピックス',
        active: true
      },
      {
        text: '',
        active: true
      }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .heading-icon {
    text-align: left !important;
    justify-content: left !important;
    .heading {
      font-size: 16px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/CmsWrapperTemplate.vue